import { wxGetToken, isUserInfo, setBaseInfo, getUserInfo, getVerificationCode } from '@/api/login'
import { getToken, setToken, getUserId, setUserId, getRedirectUrl, setRedirectUrl } from '@/utils/auth'
const user = {
  state: {
    userId: getUserId(),
    userName: '',
    weixinPhoto: '',
    userRole: '',
    authStatus: 0,
    loginToken: getToken(),
    redirectUrl: getRedirectUrl(),
    weixinId: '',
    status: 1,
    phone: '',
    email: '',
    theatreName: '',
    theatreCode: '',
    theatreAddress: '',
    code: ''
  },
  mutations: {
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
    SET_WEIXINPHOTO: (state, weixinPhoto) => {
      state.weixinPhoto = weixinPhoto
    },
    SET_USERROLE: (state, userRole) => {
      state.userRole = userRole
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_THEATRENAME: (state, theatreName) => {
      state.theatreName = theatreName
    },
    SET_THEATRECODE: (state, theatreCode) => {
      state.theatreCode = theatreCode
    },
    SET_THEATREADDRESS: (state, theatreAddress) => {
      state.theatreAddress = theatreAddress
    },
    SET_BASEINFO: (state, object) => {
      Object.assign(state, object)
    },
    SET_TOKEN: (state, token) => {
      state.loginToken = token
    },
    SET_REDIRECTURL: (state, redirectUrl) => {
      state.redirectUrl = redirectUrl
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_AUTHSTATUS: (state, authStatus) => {
      state.authStatus = authStatus
    },
    SET_CODE: (state, code) => {
      state.code = code
    }
  },
  actions: {
    WxGetToken ({ commit }, code) {
      return new Promise((resolve, reject) => {
        wxGetToken(code).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.data.loginToken)
          setToken(data.data.loginToken)
          commit('SET_USERID', data.data.userId)
          setUserId(data.data.userId)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetBaseInfo ({commit}, object) {
      return new Promise((resolve, reject) => {
        setBaseInfo(object).then(response => {
          commit('SET_BASEINFO', object)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetUserInfo ({commit, state}, object) {
      return new Promise((resolve, reject) => {
        commit('SET_USERNAME', object.userName)
        commit('SET_AUTHSTATUS', object.authStatus)
        commit('SET_STATUS', object.status)
        commit('SET_WEIXINPHOTO', object.weixinPhoto)
        commit('SET_USERROLE', object.userRole)
        commit('SET_PHONE', object.phone)
        commit('SET_EMAIL', object.email)
        commit('SET_THEATRENAME', object.theatreName)
        commit('SET_THEATRECODE', object.theatreCode)
        commit('SET_THEATREADDRESS', object.theatreAddress)
        resolve()
      })
    },
    SetRedirectUrl ({ commit, state }, redirectUrl) {
      commit('SET_REDIRECTURL', redirectUrl)
      setRedirectUrl(redirectUrl)
    },
    SetCode ({ commit }, code) {
      return new Promise((resolve, reject) => {
        commit('SET_CODE', code)
        resolve()
      })
    },
    IsUserInfo ({ commit }, userId) {
      return new Promise((resolve, reject) => {
        isUserInfo(userId).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.userId).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取手机验证码
    GetVerificationCode ({ commit }, phone) {
      return new Promise((resolve, reject) => {
        getVerificationCode(phone).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js